import React from 'react';
import { newLogoReachOk64 } from 'reports/base64Images';
import { groupBy, mixtureSubstancesByMixture } from 'selectors/generic';
import store from 'source/store';
import theme from 'source/theme';
import { MIXTURE } from 'utils/constants/coreConstants';
import { shortDate } from 'utils/helperFunctions/dateFormat';

// `product.product_raw_materials` - the composition rows of a product.
const compositionByProduct = groupBy('productRawMaterials', 'product_id');

const themeMain = theme.palette.primary.main;
const themeLight = theme.palette.primary.light;
const lightGrey = '#EEEEEE';

const productHeader = [
  { text: 'Código produto', fillColor: themeLight, colSpan: 2 },
  { text: 'Nome produto', fillColor: themeLight, colSpan: 3 },
  { text: '', fillColor: themeLight },
  { text: '', fillColor: themeLight },
  { text: '', fillColor: themeLight },
  { text: 'Perigoso', fillColor: themeLight }
];
const substanceHeader = [
  { text: 'EC', alignment: 'center' },
  { text: 'CAS', alignment: 'center' },
  { text: 'Substância/Polímero' },
  { text: 'MP carga', alignment: 'center' },
  { text: 'Produto Final ', alignment: 'center' },
  { text: 'Campo 3 FDS', alignment: 'center' }
];
const mixtureHeader = [
  { text: '', fillColor: lightGrey },
  { text: 'Código MP', fillColor: lightGrey },
  { text: 'Mistura', fillColor: lightGrey },
  { text: 'MP carga', alignment: 'center', fillColor: lightGrey },
  { text: 'Produto Final ', alignment: 'center', fillColor: lightGrey },
  { text: 'Campo 3 FDS', alignment: 'center', fillColor: lightGrey }
];

const rowGenerator = (products, rawMaterialsById) => {
  let rows = [];

  const state = store.getState();
  const compositionOf = compositionByProduct(state);
  // `mixture.substances` - what a mixture is made of, keyed by the mixture's
  // raw material id, which is what a composition row's raw_material_id holds
  // when that raw material is a MIXTURE.
  const substancesOf = mixtureSubstancesByMixture(state);

  products.forEach(product => {
    const productRawMaterials = compositionOf[product.id] || [];

    rows.push([
      { text: product.code, fillColor: themeMain, colSpan: 2 },
      { text: '', fillColor: themeMain },
      { text: product.name, fillColor: themeMain, colSpan: 3 },
      { text: '', fillColor: themeMain },
      { text: '', fillColor: themeMain },
      { text: product.hazardous ? 'x' : '', alignment: 'center', fillColor: themeMain }
    ]);

    const summaryRawMaterials = [];
    const substancesFromMixtureIds = [];
    /**
     * Algorithm to filter:
     *  - Subtances from mixtures in CARGA
     *  - Substances in CARGA
     *  - Substances in MP FINAL
     */

    /**
     * First adding all substances related with mixtures, assuming that the substance
     * has not been modified in exclusions AND all substances that have code (CARGA)
     **/
    productRawMaterials.forEach(prm => {
      if (prm.added_to_charge) {
        if (rawMaterialsById[prm.raw_material_id].type === MIXTURE) {
          (substancesOf[prm.raw_material_id] || []).forEach(interSubstance => {
            const substanceId = interSubstance.substance_id;
            substancesFromMixtureIds.push(substanceId);
            summaryRawMaterials.push({
              ...rawMaterialsById[substanceId],
              raw_material_final: false,
              added_to_charge: true,
              excluded_from_final_product: false,
              product_raw_material_id: null,
              contributes_to_hazard: false,
              code: rawMaterialsById[prm.raw_material_id].code,
              mixture_name: rawMaterialsById[prm.raw_material_id].name,
              mixture_substance_id: prm.raw_material_id
            });
          });
        } else if (!prm.mixture_id) {
          summaryRawMaterials.push({
            ...rawMaterialsById[prm.raw_material_id],
            raw_material_final: prm.raw_material_final,
            added_to_charge: prm.added_to_charge,
            excluded_from_final_product: prm.excluded_from_final_product,
            product_raw_material_id: prm.id,
            contributes_to_hazard: prm.contributes_to_hazard,
            mixture_name: '',
            mixture_substance_id: null
          });
        }
      }
    });
    /**
     * Finding Substances that overlap with the default/lazy ones created above
     * and putting these ones on top
     **/
    productRawMaterials.forEach(prm => {
      if (prm.mixture_id && prm.added_to_charge) {
        const index = summaryRawMaterials.findIndex(s =>
          s.id === prm.raw_material_id &&
          s.mixture_substance_id === prm.mixture_id
        );
        if (index >= 0) {
          summaryRawMaterials[index] =
            {
              ...summaryRawMaterials[index],
              product_raw_material_id: prm.id,
              excluded_from_final_product: prm.excluded_from_final_product,
              contributes_to_hazard: prm.contributes_to_hazard
            };
        }
      }
    });
    /**
     * Finding Substances with raw_material_final True (FINAL)
     */
    productRawMaterials.forEach(prm => {
      if (!prm.added_to_charge && !prm.mixture_id ) {
        summaryRawMaterials.push({
          ...rawMaterialsById[prm.raw_material_id],
          raw_material_final: prm.raw_material_final,
          added_to_charge: prm.added_to_charge,
          excluded_from_final_product: prm.excluded_from_final_product,
          product_raw_material_id: prm.id,
          contributes_to_hazard: prm.contributes_to_hazard,
          code: null,
          mixture_name: null
        });
      }
    });


    /**
     * Searching for substances that might be repeated in Mixtures or just as
     * Substances in CARGA and Substances added in MP FINAL to concatenate them
     */
    const finalProductRawMaterials = [];
    const sortAccented = (a, b) => {
      if (a.name && b.name) {
        return a.name.localeCompare(b.name);
      } else {
        console.log('ERROR THIS SHOULDNT HAPPEN DATA IS NOT THERE');
        return true;
      }
    };
    const sortedSubstances = summaryRawMaterials.sort(sortAccented);
    const preAnalysedIds = [];
    let i, k;

    for (i = 0; i < sortedSubstances.length; i++) {

      if (preAnalysedIds.includes(i)) {
        continue;
      }

      const repeatedSubstances = [sortedSubstances[i]];
      for (k = i + 1; k < sortedSubstances.length; k++) {
        if (sortedSubstances[i].id === sortedSubstances[k].id) {
          repeatedSubstances.push(sortedSubstances[k]);
          preAnalysedIds.push(k);
        }
      }

      finalProductRawMaterials.push([
        { text: repeatedSubstances[0]['ec'], border: [false, true, false, false] },
        { text: repeatedSubstances[0]['cas'], border: [false, true, false, false] },
        { text: repeatedSubstances[0]['name'], border: [false, true, false, false] },
        { text: repeatedSubstances.some(s => s.added_to_charge) ? 'x' : '', alignment: 'center' },
        { text: repeatedSubstances.some(s => s.excluded_from_final_product) ? '' : 'x', alignment: 'center' },
        { text: repeatedSubstances.some(s => s.contributes_to_hazard) ? 'x' : '', alignment: 'center' }
      ]);
      if (repeatedSubstances.some(s => s.mixture_name && s.mixture_name !== '') || repeatedSubstances.length > 1) {
        repeatedSubstances.forEach((s, index) => {
          if (!s.added_to_charge && !s.mixture_id) {
            finalProductRawMaterials.push([
              { text: '', border: [false, false, false, false] },
              { text: '', fillColor: lightGrey },
              { text: 'REACÇÃO', fillColor: lightGrey },
              { text: s.added_to_charge ? 'x' : '', alignment: 'center', fillColor: lightGrey },
              { text: s.excluded_from_final_product ? '' : 'x', alignment: 'center', fillColor: lightGrey },
              { text: s.contributes_to_hazard ? 'x' : '', alignment: 'center', fillColor: lightGrey }
            ]);
          } else {
            finalProductRawMaterials.push([
              { text: '', border: [false, false, false, false] },
              { text: s.code, fillColor: lightGrey },
              { text: s.mixture_name && s.mixture_name !== '' ? s.mixture_name : s.name, fillColor: lightGrey },
              { text: s.added_to_charge ? 'x' : '', alignment: 'center', fillColor: lightGrey },
              { text: s.excluded_from_final_product ? '' : 'x', alignment: 'center', fillColor: lightGrey },
              { text: s.contributes_to_hazard ? 'x' : '', alignment: 'center', fillColor: lightGrey }
            ]);
          }
        });
      }
    }

    rows = [...rows, ...finalProductRawMaterials];
  });

  return rows;
};


const dd = (products, rawMaterialsById) => ({
  pageSize: 'A4',
  pageOrientation: 'landscape',
  pageMargins: [40, 60, 40, 40],

  footer: function (currentPage, pageCount) {
    return {
      text: `${shortDate(new Date())} - ${currentPage.toString()} de ${pageCount}`,
      alignment: 'right',
      relativePosition: { x: -15, y: 20 },
      fontSize: 7
    };
  },
  header: function (currentPage, pageCount, pageSize) {
    return [
      {
        image: newLogoReachOk64,
        width: 50,
        relativePosition: { x: 20, y: 10 }
      }
    ];
  },
  content: [
    {
      style: 'header',
      text: 'R - Composição do Produto'
    },
    {
      style: 'tableExample',
      layout: 'lightHorizontalLines',
      table: {
        headerRows: 3,
        widths: [100, 100, 240, 70, 70, 70],
        body: [
          productHeader,
          substanceHeader,
          mixtureHeader,
          ...rowGenerator(products, rawMaterialsById)
        ]
      }
    }
  ],
  styles: {
    header: {
      color: theme.palette.primary.main,
      fontSize: 16,
      bold: true,
      alignment: 'center'
    },
    tableExample: {
      margin: [0, 15, 0, 0],
      fontSize: 8
    }
  }

});

export default dd;
